<template>
  <div class="formwork-one" :class="`posation-${posation}`">
    <router-link :to="{name:'personal',params:{id:row.Author.Id}}">
      <Avatar class="img" :size="25" :src="row.Author.Avatar"></Avatar>
    </router-link>
    <div class="content">
      <router-link :to="{name:'personal',params:{id:row.Author.Id}}">
        <div class="author">
          <div class="van-ellipsis">{{row.Author.NickName}}</div>
            <svg v-if="row.Author.Type === 1" class="svg-icon author-icon" aria-hidden="true">
              <use xlink:href="#icon-qiye1" />
            </svg>
            <svg v-if="row.Author.Type === 14" class="svg-icon author-icon" aria-hidden="true">
              <use xlink:href="#icon-zhuanjia" />
            </svg>  
            <svg v-if="row.Author.Type === 22" class="svg-icon author-icon" aria-hidden="true">
              <use xlink:href="#icon-hangjia" />
            </svg> 
        </div>
        <div v-show="hasFollow" class="text-gray">粉丝数：{{row.Author.FollowedQuantity}}</div>
        <div v-show="hasIntroduction" class="text-gray van-ellipsis">{{row.Author.Introduction}}</div>
        <div v-show="createTime" class="text-gray van-ellipsis">{{createTime | datetime-second-parse}}</div>
      </router-link>
      <slot></slot>
    </div>
  </div>    
</template>

<script>
import Avatar from '@/components/avatar'
export default {
  name: 'formworkOne',
  components: { Avatar },
  props: {
    hasTag: {
      type: Boolean,
      default: true
    },
    hasFollow: {
      type: Boolean,
      default: false
    },
    hasIntroduction: {
      type: Boolean,
      default: true
    },
    createTime: {
      type: String,
      default: ''
    },
    posation: {
      type: String,
      default: 'center'
    },
    row: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid $gray;
}
.posation-center {
  align-items: center;
}
.posation-top {
  align-items: flex-start;
}
.formwork-one {
  display: flex;
  background: #fff;
  overflow: hidden;
  span {
    font-size: $font-size-small;
  }
  .img {
    width: 46px;
    height: 46px;
    margin-right: 12px;
    overflow: hidden;
    flex: none;
  }
  .content {
    max-width: 200px;
    overflow: hidden;
  }
  .author {
    // margin-bottom: 10px;
    div {
      display: inline-block;
      max-width: 7em;
      vertical-align: middle;
      margin-right: 6px;
    }
    .author-icon {
      width: 24px;
      height: 20px;
      vertical-align: middle;
    }
  }
}
</style>
